function cleanWWDOLocalStorage (options = { force: false }) {
  if (options.force || new Date(localStorage.getItem('wwdo-expiration')) <= new Date()) {
    localStorage.removeItem('wwdo-job');
    localStorage.removeItem('wwdo-expiration');    
  }
}

export default cleanWWDOLocalStorage;